import { useRef, useState } from 'react'
import { Link, useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

//import Button from "react-bootstrap/esm/Button.js"
import Dropdown from 'react-bootstrap/Dropdown'
//import Form from 'react-bootstrap/Form'

import AboutModal from "./AboutModal"
import Icon from "./Icon"
import LoadingAnimation from "./LoadingAnimation.jsx"

//import { convertUrlReactToEmber } from "../utils/utils.js"

import { removeSelectedBusinessEntityId } from "../state/actions/userSettingsActions.js"

import { appConfigSignal, appConfigLoadedSignal } from '../state/signals/appConfigSignals.js'
import { userManifestErrorSignal, userManifestLoadedSignal, userManifestSignal } from '../state/signals/userManifestSignals.js'
import { hasProfileImageComputed, profileImageSrcComputed } from '../state/signals/userSettingsSignals.js'

const UserBox = function () {

	const { beId } = useParams()

	const showModalAboutSignal = useSignal(false)
	const handleCloseModalAbout = function () {
		showModalAboutSignal.value = false
	}

	const menuRef = useRef(null)
	const [openMenuState, setOpenMenuState] = useState(false)

	const closeMenu = function (event) {
		if (openMenuState && !menuRef.current?.contains(event.target)) {
			setOpenMenuState(false)
		}
	}
	document.addEventListener('mousedown', closeMenu)

	const navigateTo4tressUrlComputed = useComputed(
		() => {
			if (appConfigLoadedSignal.value && appConfigSignal.value && appConfigSignal.value.fortressBaseUrl) {
				return appConfigSignal.value.fortressBaseUrl.concat("/#/profile")
			}
			return null
		}
	)

	const toggleUserBox = (open) => {
		setOpenMenuState(open)
	}

	if (!userManifestLoadedSignal.value || userManifestErrorSignal.value) {
		return
	}

	return (
		<>
			<Dropdown id="userbox" ref={menuRef} show={openMenuState} onToggle={toggleUserBox}>
				<Dropdown.Toggle
					style={{
						height: "50px",
						backgroundColor: "inherit",
						color: "inherit",
						border: "none",
						transition: "none"
					}}
				>
					{
						(!appConfigLoadedSignal.value || !userManifestLoadedSignal.value) ? (
							<LoadingAnimation />
						) : (
							hasProfileImageComputed.value && (<img className="profile-image" src={profileImageSrcComputed.value} />)
						)
					}
					<span className="username">{
						(!userManifestLoadedSignal.value || !userManifestSignal.value) ? (<LoadingAnimation />) : (
							userManifestSignal.value.username
						)
					}</span>
					<span style={{ position: "absolute", right: "0.6rem" }} className="icon-wrapper">
						<Icon icon="chevron-down" width={16} height={16}></Icon>
					</span>
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Link
						to={`/be/${beId}/profile`}
						className="dropdown-item"
						onClick={
							() => {
								setOpenMenuState(false)
							}
						}
					>
						<span className="me-1">
							<Icon icon="person-circle" height={16} width={16} />
						</span>
						My Profile
					</Link>
					{
						!appConfigLoadedSignal.value ? (<LoadingAnimation />) : (
							navigateTo4tressUrlComputed.value && (
								<Dropdown.Item href={navigateTo4tressUrlComputed.value}>
									<span className="me-1">
										<Icon icon="lock" height={16} width={16} />
									</span>
									Navigate to 4tress
								</Dropdown.Item>
							)
						)
					}
					<Dropdown.Item onClick={() => { showModalAboutSignal.value = true; }}>
						<label>
							<span className="me-1">
								<Icon icon="info-circle" height={16} width={16}></Icon>
							</span>
							About
						</label>
					</Dropdown.Item>
					{
						!appConfigLoadedSignal.value ? (<LoadingAnimation />) : (
							<Dropdown.Item onClick={() => removeSelectedBusinessEntityId()} href={`${appConfigSignal.value.ssoBaseUrl}/logout?clientid=4&redirectToReferer=true`}>
								<span className="me-1">
									<Icon icon="sign-out" height={16} width={16}></Icon>
								</span>
								Sign Out
							</Dropdown.Item>
						)
					}
				</Dropdown.Menu>
			</Dropdown>
			<AboutModal showSignal={showModalAboutSignal} handleCancel={handleCloseModalAbout}></AboutModal>
		</>
	)
}
export default UserBox